import './PeriscopeTypeLabel.scss';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { Tooltip } from 'antd';
import { displayFieldType, getSonarObjectTypeLabel } from '@sonar-software/sonar-ts-lib';

export interface PeriscopeCardTabProps {
	headerLabel?: string;
	sonarObjectType: SonarObjectType;
	subType?: string;
}

export const PeriscopeTypeLabel: React.FC<PeriscopeCardTabProps> = ({ headerLabel, sonarObjectType, subType }) => {
	const displayText = headerLabel ?? getSonarObjectTypeLabel(sonarObjectType);
	const subtypeText = displayFieldType(subType ?? '');

	return (
		<div className='periscope-type-subtype-labels'>
			<div className='periscope-type-label'>{ displayText }</div>
			{ Boolean(subType) &&
				<Tooltip title={ subtypeText }>
					<div className='periscope-subtype-label'>{ subtypeText }</div>
				</Tooltip> }
		</div>
	);
};
